export const adminLogKeys = {
  all: ['admin-logs'],
  bukuTarifAll: () => ['admin-logs', 'buku-tarif'],
  bukuTarifList: (params) => ['admin-logs', 'buku-tarif', 'list', params],
  bukuTarifDetail: (id) => ['admin-logs', 'buku-tarif', 'detail', id],
  insuranceClaimLogAll: () => ['admin-logs', 'insurance-claim-log'],
  insuranceClaimLogList: (params) => [
    'admin-logs',
    'insurance-claim-log',
    'list',
    params,
  ],
  insuranceClaimLogDetail: (id) => [
    'admin-logs',
    'insurance-claim-log',
    'detail',
    id,
  ],
};

export const adminLogStaleTime = {
  LIST: 5 * 60 * 1000,
  DETAIL: 5 * 60 * 1000,
};
